// extracted by mini-css-extract-plugin
export default {"isLoading":"hXAs9","thumbnailContainer":"tRtUI","productCardContainer":"ygAVf","uppercaseTitle":"uRg24"};